// extracted by mini-css-extract-plugin
export default {"card":"CampaignCard_card__qOLma","cardIcon":"CampaignCard_cardIcon__B3Qww","title":"CampaignCard_title__Q+VlK","description":"CampaignCard_description__P7S7v"};